export const REPORT_CENTER_MODULES = {
    qa: 'qa',
    accessibility: 'accessibility',
    seo: 'seo',
    statistics: 'stats',
    heartbeat: 'uptime',
    heatmaps: 'heatmaps',
    policy: 'policy',
    other: 'other',
} as const;
